import type { TFunction } from 'i18next'
import type { ReactNode } from 'react'
import type { Dayjs } from '../../dayjs.ts'

export interface DateRange {
	id: string
	label: (t: TFunction) => ReactNode
	getRange: (clock: Dayjs) => { start: Dayjs; end: Dayjs }
}

export const defaultDateRange: DateRange = {
	id: 'last-4-hours',
	label: (t: TFunction) => t(($) => $.timeline.dateRanges.lastXhour, { hours: 4 }),
	getRange: (clock: Dayjs) => ({ start: clock.subtract(4, 'hour'), end: clock }),
}

export const dateRanges = [
	{
		id: 'last-24-hours',
		label: (t: TFunction) => t(($) => $.timeline.dateRanges.lastXhour, { hours: 24 }),
		getRange: (clock: Dayjs) => ({ start: clock.subtract(24, 'hour'), end: clock }),
	},
	defaultDateRange,
	{
		id: 'last-2-hours',
		label: (t: TFunction) => t(($) => $.timeline.dateRanges.lastXhour, { hours: 2 }),
		getRange: (clock: Dayjs) => ({ start: clock.subtract(2, 'hour'), end: clock }),
	},
	{
		id: 'between-24-hours',
		label: (t: TFunction) => t(($) => $.timeline.dateRanges.betweenXhour, { hours: 24 }),
		getRange: (clock: Dayjs) => ({ start: clock.subtract(24, 'hour'), end: clock.add(24, 'hour') }),
	},
	{
		id: 'next-24-hours',
		label: (t: TFunction) => t(($) => $.timeline.dateRanges.nextXhour, { hours: 24 }),
		getRange: (clock: Dayjs) => ({ start: clock, end: clock.add(24, 'hour') }),
	},
	{
		id: 'next-3-days',
		label: (t: TFunction) => t(($) => $.timeline.dateRanges.nextXday, { days: 3 }),
		getRange: (clock: Dayjs) => ({ start: clock, end: clock.add(3, 'day') }),
	},
	{
		id: 'next-7-days',
		label: (t: TFunction) => t(($) => $.timeline.dateRanges.nextXday, { days: 7 }),
		getRange: (clock: Dayjs) => ({ start: clock, end: clock.add(7, 'day') }),
	},
	{
		id: 'next-14-days',
		label: (t: TFunction) => t(($) => $.timeline.dateRanges.nextXday, { days: 14 }),
		getRange: (clock: Dayjs) => ({ start: clock, end: clock.add(14, 'day') }),
	},
] as const
